/*  ========================================================================
    # Section - Hero Full
    ========================================================================  */

import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import Lightbox from '../../components/Lightbox';
import TrailerPreview from '../../components/TrailerPreview';

const HeroFull = ({ trailer, trailerThumbnail }) => {
  const [trailerOpened, setTrailerOpened] = useState(false);
  const [selectedTrailer, setSelectedTrailer] = useState(trailer.url);
  const trailerRef = useRef(null);

  // Start the trailer playback
  const startTrailer = trigger => {
    if (trigger?.dataset?.trailerTrigger) {
      setSelectedTrailer(trigger.dataset.trailerTrigger);
    } else {
      setSelectedTrailer(trailer.url);
    }
    setTrailerOpened(true);
  };

  // End the trailer playback
  const closeTrailer = useCallback(() => {
    trailerRef.current?.pause();
    setTrailerOpened(false);
  }, []);

  // Get all additional trailer trigger
  useEffect(() => {
    const triggers = document.querySelectorAll('[data-trailer-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => startTrailer(trigger));
    });
    return () => {
      triggers.forEach(trigger => {
        trigger.removeEventListener('click', startTrailer);
      });
    };
  }, []);

  return (
    <>
      <TrailerPreview trailerThumbnail={trailerThumbnail} onClick={startTrailer} />
      <Lightbox show={trailerOpened} onClose={closeTrailer}>
        <video
          ref={trailerRef}
          src={trailerOpened ? selectedTrailer : null}
          controls={true}
          loop={false}
          autoPlay
        />
      </Lightbox>
    </>
  );
};

HeroFull.propTypes = {
  trailer: PropTypes.object,
  trailerThumbnail: PropTypes.object
};

export default HeroFull;
